export const brandFunnelCompetitorsEndPoint = `brand-funnel`;
